import React from 'react';
import { Link } from 'react-router-dom';

const TopNav = ({ searchQuery, onSearchChange, variant = 'glass' }) => {
  const isTransparent = variant === 'transparent';

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isTransparent
        ? 'bg-transparent backdrop-blur-md'
        : 'bg-surface/80 backdrop-blur-xl bg-gradient-to-b from-surface to-transparent shadow-[0px_12px_32px_rgba(0,0,0,0.4)]'
    }`}>
      <div className="flex justify-between items-center px-8 py-4 w-full">
        <div className="flex items-center gap-8">
          <Link to="/" className="font-headline italic text-2xl text-primary hover:text-primary-fixed-dim transition-colors">
            Migration Journal
          </Link>
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/explorer" className="text-primary border-b-2 border-primary pb-1 font-label uppercase tracking-widest text-xs">
              Explorer
            </Link>
          </div>
        </div>
        <div className="flex items-center gap-4">
          {onSearchChange && (
            <div className="relative">
              <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm">search</span>
              <input
                className="bg-surface-container-lowest rounded-xl py-2 pl-10 pr-4 text-sm text-on-surface focus:ring-1 focus:ring-primary/40 w-48 md:w-64 transition-all duration-300 placeholder:text-slate-600 font-body"
                placeholder="Search species..."
                type="text"
                value={searchQuery || ''}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          )}
          <Link to="/admin/login" className="text-primary hover:scale-95 duration-200" title="Admin">
            <span className="material-symbols-outlined">account_circle</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default TopNav;
